import dashboardKomship from './dashboard-komship'

export default [
  ...dashboardKomship,
]
